export default {
  header: {
    language: 'Idioma',
    portuguese: 'Português',
    english: 'Inglês',
    home: 'Home',
    services: 'Serviços',
    about: 'Sobre',
    youtube: 'Youtube',
    games: 'Games',
  },
  not_found: {
    title: 'Página não encontrada',
    return: 'Retonar ao',
  },
  footer: {
    info: 'Todos os direitos reservados',
  },
  home: {
    intro: 'Serviços de consultoria especializada, com foco em desenvolvimento de software e computação em nuvem',
    additional: 'Criamos soluções personalizadas e otimizadas, de acordo com sua necessidade, para garantir uma excelente performance e custo-benefício',
  },
  cookies_policy: {
    cookies_preferences: 'Suas preferências de cookies',
    policy: 'Política de Cookies',
    header: 'Usamos cookies para otimizar nosso site e coletar estatísticas de uso.',
    info_1_header: 'Informações sobre nosso uso de cookies',
    info_1_text: 'Este website utiliza cookies para proporcionar uma boa experiência de navegabilidade aos usuários, permitindo-nos também aperfeiçoá-lo.',
    info_2_header: 'O que é um cookie?',
    info_2_text: 'Um cookie é um pequeno arquivo de letras e números que armazenamos no navegador do usuário ou no hard disk (HD) do seu computador, desde que o usuário concorde. Os cookies contêm informação que se transfere ao hard disk do computador do usuário.',
    accept_cookies: 'Aceitar cookies',
  },
  services: {
    article_1_title: 'WIKI PEP',
    article_1_info: 'WIKI PEP é uma plataforma de consulta e pesquisa de Pessoas Politicamente Expostas (PEPs), fornecendo informações detalhadas sobre suas identidades, cargos públicos, histórico político e conexões relevantes',
    article_1_link_text: 'Acesse o WIKI PEP',
  },
  about: {
    article_1_text_1: 'A Blackdevs é uma empresa fundada em 2018, com objetivo de ajudar outras empresas a alavancarem seu negócios com auxílio da tecnologia, automatizando processos manuais, reduzindo custos, utilizando o que há de mais moderno no mundo da tecnologia',
    article_1_text_2: 'O fundador é um profissional experiente com uma base sólida em desenvolvimento de software, computação em nuvem e IA. Proficiente na construção de APIs REST e serviços de backend usando NodeJS, TypeScript, Python, Java e Golang, com foco em  microservices e serverless architectures',
    article_2_title: 'Fundador',
    article_2_text_1: 'Certificado em Cloud Computing',
  },
  youtube: {
    title: 'Canal no Youtube',
    latest_videos: 'Últimos vídeos',
    loading: 'Carregando',
    subscribers: 'Inscritos',
    views: 'Visualizações',
  },
  games: {
    latest_games: 'Últimos games',
    loading: 'Carregando',
    downloads: 'Downloads',
  },
  buttons: {
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Salvar',
    edit: 'Editar',
    delete: 'Apagar',
    clear: 'Limpar Campos',
    return: 'Voltar',
    login: 'Login',
  },
  messages: {
    errors: {
    },
    success: {
    },
  },
  dates: {
    long_date_format: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD/MM/YYYY',
      LL: 'D [de] MMMM [de] YYYY',
      LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
      LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
    },
    previous_month: 'Mês Anterior',
    next_month: 'Próximo Mês',
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    weekdays: [
      'Domingo',
      'Segunda',
      'Terça',
      'Quarta',
      'Quinta',
      'Sexta',
      'Sábado',
    ],
    weekdays_short: [
      'Dom',
      'Seg',
      'Ter',
      'Qua',
      'Qui',
      'Sex',
      'Sáb',
    ],
  },
  validations: {
    messages: {
      _default: 'Campos invalidos',
    },
  },
};
